import React from 'react'
import { AddToChromeButton } from '@mote/presentation'
import { Content, DefaultLayout } from '../layouts'
import { Block, BlockGroup, H2, H3, P } from '@mote/ui'
import styled from 'styled-components'

export const TeamsScreen = () => {
  return (
    <Root>
      <Content>
        <Block
          as='section'
          style={{
            backgroundPosition: '50%',
            backgroundRepeat: 'no-repeat',
            backgroundImage: 'url(images/logos/mote-background.png',
            backgroundSize: 'auto'
          }}
        >
          <BlockGroup margin='20px 0 0 0' gap={60}>
            <H2 alignment='center'>
              Teams use <b className='mote-purple'>mote</b> to stay connected
            </H2>

            <Block layout='horizontal' gap={80} align='center'>
              <Block maxWidth={500} gap={15}>
                <H3>Together Alone</H3>
                <P>
                  We've designed <b className='mote-purple'> mote</b> to help
                  you work remotely, and on your own schedule, without
                  sacrificing human connection.
                </P>
              </Block>

              <figure>
                <img
                  src='images/photos/CrowdedHouse.jpg'
                  width='500'
                  alt='Crowded House'
                />
                <figcaption className='figure-caption text-center'>
                  <small>Crowded House in 1993</small>
                </figcaption>
              </figure>
            </Block>

            <Block layout='horizontal' gap={80} align='center'>
              <figure>
                <img
                  src='images/photos/nina-simone-please-dont-let-me.jpg'
                  width='500'
                  alt='Nina Simone'
                />
                <figcaption>
                  <small>Nina Simone in 1964</small>
                </figcaption>
              </figure>
              <Block maxWidth={500} gap={15}>
                <H3>Don't let me be misunderstood</H3>
                <P>
                  You're just a soul whose intentions are good, but sometimes
                  words on a screen just don't quite capture what you want to
                  say.
                </P>
                <a className='link-cta' href='/beunderstood'>
                  Read more
                </a>
              </Block>
            </Block>

            <Block layout='horizontal' gap={80} align='center'>
              <Block maxWidth={500} gap={15}>
                <H3>Pleased to meet you...</H3>
                <P>
                  But perhaps next time, we can work this through online and
                  save a bunch of time and delay? With{' '}
                  <b className='mote-purple'> mote</b>, everyone can read and
                  summarize their feedback quickly and easily.
                </P>
                <a href='/pleased'>Read more</a>
              </Block>
              <figure>
                <img
                  src='images/photos/Stones1982RotterdamMarcelAntonisse.jpg'
                  className='img-fluid'
                  width='500'
                  alt='Mick Jagger'
                />
                <figcaption className='figure-caption text-center'>
                  <small>Mick Jagger in 1982</small>
                </figcaption>
              </figure>
            </Block>

            <Block layout='horizontal' gap={80} align='center'>
              <figure>
                <img
                  src='images/photos/dolly-parton-9to5.png'
                  width='500'
                  alt='Dolly Parton'
                />
                <figcaption className='figure-caption text-center' width='500'>
                  <small>Dolly Parton in 1980</small>
                </figcaption>
              </figure>
              <Block maxWidth={500} gap={15}>
                <H3>9 to 5</H3>
                <P>
                  What a way to make a livin' ... but modern teams operate
                  around the globe, around the clock and however works best.{' '}
                  <b className='mote-purple'>mote</b> is a great tool to help
                  empower your distributed team to succeed.{' '}
                </P>
              </Block>
            </Block>

            <Block gap={20} margin='40px auto 40px auto' align='center'>
              <H3 alignment='center'>Are you ready to start?</H3>
              <AddToChromeButton />
            </Block>
          </BlockGroup>
        </Block>
      </Content>
    </Root>
  )
}

const Root = styled(DefaultLayout)`
  section {
    a {
      color: #ac0ae8;
      text-transform: uppercase;
      text-decoration: underline;
      &:hover {
        text-decoration: none;
      }

      &:focus,
      &:active,
      &:visited {
        color: #ac0ae8;
      }
    }
  }
`
